export default __webpack_public_path__ + "static/media/grafema_the-essence-collective_04.4ea883ed.jpg";